import React from 'react';

function SvgArrowLeft(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.268 21.998a.58.58 0 00.454-.412.596.596 0 00-.162-.597l-5.343-5.387h17.227a.585.585 0 00-.055-1.17H7.217l5.343-5.387a.588.588 0 00-.235-1.03.578.578 0 00-.583.205L5.4 14.595l-.4.422.4.422 6.342 6.375a.58.58 0 00.473.184h.053z"
        fill={props.color || '#414B56'}
      />
    </svg>
  );
}

export default SvgArrowLeft;
